export default __webpack_public_path__ + "static/signupMobile-0aace72a1c2859511ac353ccae0e3234.png";